import { raiderClient } from './client'
import type { ServiceConfigParam } from '../types'

export const getRaiderConfig = () =>
  raiderClient.get<ServiceConfigParam[]>('/config')

export const setRaiderConfig = (key: string, value: string) =>
  raiderClient.post('/config', { [key]: value })

export const getParseJob = (documentId: string) =>
  raiderClient.get(`/parse-jobs/${documentId}`)
